import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import { useSidebar } from "../../context/SidebarContext";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const navItems = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    label: "Users",
    to: "/user",
    isExpandable: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#ffff00]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    children: [
      { to: "/user", label: "All Users" },
      { to: "/today-users", label: "Today's Users", type: "Live" },
      { to: "/stuck-mining-users", label: "Stuck Mining Users", type: "Fix" },
      { to: "/duplicate-account", label: "Duplicate Accounts" },
      { to: "/user-notifications", label: "Push Notifications", type: "Push" },
      { to: "/adblocker-logs", label: "Adblocker Logs", type: "Sec" },
    ],
  },
  {
    label: "Events",
    to: "/events",
    isExpandable: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#ffff00]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    children: [
      { to: "/events", label: "All Events" },
      { to: "/events/winners", label: "Reward Coin Approval", type: "Approval" },
      { to: "/events/notifications", label: "Event Notifications", type: "Ledger" },
      { to: "/events/points-audit", label: "Event Points Audit", type: "Audit" },
    ],
  },
  {
    label: "Games",
    to: "/games",
    isExpandable: true,
    icon: (
      <span className="text-sm">🎮</span>
    ),
    children: [
      { to: "/games", label: "All Games & Priority" },
      { to: "/game/timer", label: "Timer Reward", type: "Live" },
      { to: "/game/2048", label: "2048 Game", type: "New" },
      { to: "/game/fruit-bomb", label: "Fruit Bomb", type: "New" },
      { to: "/boom-cards", label: "Boom Cards", type: "Live" },
      { to: "/tap-game", label: "Tap & Earn", type: "Live" },
      { to: "/slots-game", label: "777 Slots", type: "Live" },
      { to: "/spin-wheel", label: "Spin Wheel", type: "Live" },
    ],
  },
  {
    label: "KYC",
    to: "/kyc",
    isExpandable: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#ffff00]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    children: [
      { to: "/kyc", label: "KYC Steps & Rules" },
      { to: "/kyc-users", label: "KYC Users List" },
    ],
  },
  {
    to: "/announcement",
    label: "Announcement",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
      </svg>
    ),
  },
  {
    to: "/notifications",
    label: "Notification",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    ),
  },
  {
    to: "/settings",
    label: "Settings",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

const Sidebar = () => {
  const { isOpen, toggle, close } = useSidebar();
  const location = useLocation();
  const navigate = useNavigate();

  const isInsideUsers =
    location.pathname.startsWith("/user") ||
    location.pathname.startsWith("/today-users") ||
    location.pathname.startsWith("/today-registered-users") ||
    location.pathname.startsWith("/stuck-mining-users") ||
    location.pathname.startsWith("/duplicate-account") ||
    location.pathname.startsWith("/duplicate-users") ||
    location.pathname.startsWith("/coin-history") ||
    location.pathname.startsWith("/user-notifications") ||
    location.pathname.startsWith("/push-notifications") ||
    location.pathname.startsWith("/adblocker-logs");

  const isInsideEvents =
    location.pathname.startsWith("/events") ||
    location.pathname.startsWith("/admin/event-notifications");
  const isInsideGames =
    location.pathname.startsWith("/game") ||
    location.pathname.startsWith("/games") ||
    location.pathname.startsWith("/boom-cards") ||
    location.pathname.startsWith("/tap-game") ||
    location.pathname.startsWith("/slots-game") ||
    location.pathname.startsWith("/slots") ||
    location.pathname.startsWith("/spin-wheel") ||
    location.pathname.startsWith("/spinwheel") ||
    location.pathname.startsWith("/fruit-bomb") ||
    location.pathname.startsWith("/game-2048") ||
    location.pathname.startsWith("/timer-game");
  const isInsideKYC = location.pathname.startsWith("/kyc");

  const [expandedMenus, setExpandedMenus] = useState({
    Users: isInsideUsers,
    Events: isInsideEvents,
    Games: isInsideGames,
    KYC: isInsideKYC,
  });

  useEffect(() => {
    if (isInsideUsers) {
      setExpandedMenus((prev) => ({ ...prev, Users: true }));
    }
    if (isInsideEvents) {
      setExpandedMenus((prev) => ({ ...prev, Events: true }));
    }
    if (isInsideGames) {
      setExpandedMenus((prev) => ({ ...prev, Games: true }));
    }
    if (isInsideKYC) {
      setExpandedMenus((prev) => ({ ...prev, KYC: true }));
    }
  }, [location.pathname, isInsideUsers, isInsideEvents, isInsideGames, isInsideKYC]);

  const toggleMenu = (menuLabel) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuLabel]: !prev[menuLabel],
    }));
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        await fetch(`${baseUrl}/auth/logout`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      // proceed with logout regardless
    } finally {
      localStorage.removeItem("token");
      navigate("/");
    }
  };

  return (
    <>
      {/* Mobile hamburger toggle — always visible on mobile when sidebar is closed */}
      {!isOpen && (
        <button
          onClick={toggle}
          className="fixed top-4 left-4 z-40 lg:hidden bg-gray-900 text-white p-2.5 rounded-xl shadow-lg hover:bg-black transition"
          aria-label="Open sidebar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      )}

      {/* Mobile overlay backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-xs z-20 lg:hidden"
          onClick={close}
        />
      )}

      {/* Sidebar panel */}
      <div
        className={`
          fixed top-0 left-0 h-screen w-64 bg-gray-900 text-white flex flex-col z-30 transition-transform duration-300
          lg:sticky lg:top-0 lg:h-screen lg:translate-x-0 lg:z-auto lg:flex-shrink-0
          ${isOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"}
        `}
      >
        {/* Logo + close */}
        <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-gray-800">
          <Link to="/dashboard" className="flex items-center gap-2" onClick={close}>
            <img src={logo} className="h-8" alt="Zeta Admin Panel" />
          </Link>
          <button
            onClick={close}
            className="text-gray-400 hover:text-white lg:hidden p-1.5 rounded-lg hover:bg-gray-800 transition"
            aria-label="Close sidebar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Nav links — scrollable */}
        <ul className="flex-1 overflow-y-auto px-4 py-4 space-y-1">
          {navItems.map((item) => {
            if (item.isExpandable) {
              const isParentActive =
                item.label === "Users" ? isInsideUsers :
                item.label === "Events" ? isInsideEvents :
                item.label === "Games" ? isInsideGames :
                item.label === "KYC" ? isInsideKYC : false;
              const isMenuOpen = !!expandedMenus[item.label];

              return (
                <li key={item.label} className="space-y-1">
                  {/* Expandable Parent Button */}
                  <div
                    onClick={() => toggleMenu(item.label)}
                    className={`py-2.5 px-4 rounded-xl cursor-pointer flex items-center justify-between transition text-sm select-none
                      ${isParentActive
                        ? "text-[#ffff00] font-semibold bg-gray-800/80 border border-gray-750"
                        : "text-gray-300 hover:bg-gray-800 hover:text-white"
                      }`}
                  >
                    <span className="flex items-center gap-2.5">
                      {item.icon}
                      <span>{item.label}</span>
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-4 w-4 transition-transform duration-200 ${isMenuOpen ? "rotate-180 text-[#ffff00]" : "text-gray-400"}`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>

                  {/* Sub-items dropdown */}
                  {isMenuOpen && (
                    <ul className="pl-3 pr-1 py-1 space-y-1 border-l-2 border-gray-800 ml-5">
                      {item.children.map((sub) => {
                        let isSubActive = false;
                        if (sub.to === "/user") {
                          isSubActive =
                            location.pathname === "/user" ||
                            (location.pathname.startsWith("/user/") &&
                              !location.pathname.includes("/coin-history") &&
                              !location.pathname.startsWith("/duplicate-account") &&
                              !location.pathname.startsWith("/today-users"));
                        } else if (sub.to === "/today-users") {
                          isSubActive =
                            location.pathname === "/today-users" ||
                            location.pathname.startsWith("/today-registered-users");
                        } else if (sub.to === "/stuck-mining-users") {
                          isSubActive =
                            location.pathname === "/stuck-mining-users" ||
                            location.pathname.startsWith("/stuck-mining-users");
                        } else if (sub.to === "/duplicate-account") {
                          isSubActive =
                            location.pathname === "/duplicate-account" ||
                            location.pathname.startsWith("/duplicate-account/") ||
                            location.pathname.startsWith("/duplicate-users");
                        } else if (sub.to === "/adblocker-logs") {
                          isSubActive = location.pathname.startsWith("/adblocker-logs");
                        } else if (sub.to === "/events") {
                          isSubActive =
                            location.pathname === "/events" ||
                            (location.pathname.startsWith("/events/") &&
                              !location.pathname.includes("/winners") &&
                              !location.pathname.includes("/participants"));
                        } else if (sub.to === "/events/winners") {
                          isSubActive =
                            location.pathname.includes("/winners") ||
                            location.pathname.startsWith("/events/winners");
                        } else if (sub.to === "/games") {
                          isSubActive =
                            location.pathname === "/games" ||
                            location.pathname === "/game" ||
                            location.pathname === "/admin/games" ||
                            location.pathname === "/game/history";
                        } else if (sub.to === "/game/2048") {
                          isSubActive =
                            location.pathname === "/game/2048" ||
                            location.pathname.startsWith("/game/2048") ||
                            location.pathname === "/game-2048";
                        } else if (sub.to === "/game/fruit-bomb") {
                          isSubActive =
                            location.pathname === "/game/fruit-bomb" ||
                            location.pathname.startsWith("/game/fruit-bomb") ||
                            location.pathname.startsWith("/game/fruit-Bomb") ||
                            location.pathname === "/fruit-bomb";
                        } else if (sub.to === "/events/points-audit") {
                          isSubActive =
                            location.pathname === "/events/points-audit" ||
                            location.pathname.startsWith("/events/points-audit") ||
                            location.pathname === "/events/activity-audit";
                        } else if (sub.to === "/boom-cards") {
                          isSubActive =
                            location.pathname === "/boom-cards" ||
                            location.pathname.startsWith("/game/boomcards");
                        } else if (sub.to === "/tap-game") {
                          isSubActive =
                            location.pathname === "/tap-game" ||
                            location.pathname.startsWith("/game/tap");
                        } else if (sub.to === "/slots-game") {
                          isSubActive =
                            location.pathname === "/slots-game" ||
                            location.pathname === "/slots" ||
                            location.pathname.startsWith("/game/slots");
                        } else if (sub.to === "/spin-wheel") {
                          isSubActive =
                            location.pathname === "/spin-wheel" ||
                            location.pathname === "/spinwheel" ||
                            location.pathname.startsWith("/game/spinwheel");
                        } else if (sub.to === "/kyc") {
                          isSubActive = location.pathname === "/kyc";
                        } else if (sub.to === "/kyc-users") {
                          isSubActive = location.pathname === "/kyc-users";
                        }

                        return (
                          <li key={sub.to}>
                            <Link
                              to={sub.to}
                              onClick={close}
                              className={`py-2 px-3 rounded-lg block transition text-xs flex items-center justify-between
                                ${isSubActive
                                  ? "font-bold text-black bg-[#ffff00] shadow-sm"
                                  : "text-gray-400 hover:bg-gray-800 hover:text-gray-200"
                                }`}
                            >
                              <span className="truncate">{sub.label}</span>
                              {sub.type && (
                                <span className={`text-[9px] px-1.5 py-0.5 rounded font-bold uppercase ${isSubActive ? "bg-black text-[#ffff00]" : "bg-gray-800 text-gray-400"}`}>
                                  {sub.type}
                                </span>
                              )}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            }

            const active =
              location.pathname === item.to ||
              (item.to === "/boom-cards" &&
                (location.pathname === "/game/boomcards" ||
                  location.pathname.startsWith("/game/boomcards"))) ||
              (item.to === "/tap-game" &&
                (location.pathname === "/game" ||
                  location.pathname === "/game/tap" ||
                  location.pathname.startsWith("/game/tap")));

            return (
              <li key={item.to}>
                <Link
                  to={item.to}
                  onClick={close}
                  className={`py-2.5 px-4 rounded-xl cursor-pointer flex items-center justify-between transition text-sm
                    ${active
                      ? "font-bold text-black bg-[#ffff00] shadow-sm"
                      : "text-gray-300 hover:bg-gray-800 hover:text-white"
                    }`}
                >
                  <span className="flex items-center gap-2.5">
                    {item.icon && <span className="inline-flex">{item.icon}</span>}
                    <span>{item.label}</span>
                  </span>
                  {item.type && (
                    <span
                      className={`text-[9px] px-1.5 py-0.5 rounded font-bold uppercase ${
                        active
                          ? "bg-black text-[#ffff00]"
                          : "bg-emerald-900/60 text-emerald-300 border border-emerald-700/50"
                      }`}
                    >
                      {item.type}
                    </span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* Logout at bottom */}
        <div className="px-4 pb-6 pt-3 border-t border-gray-800">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 py-2.5 px-4 rounded-xl text-sm font-medium text-red-400 hover:bg-red-500 hover:text-white transition cursor-pointer"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
